function styleCompareAtPrice() {
  //Give products some time to load
  setTimeout(()=> {
    $('.money-details').each(function(){
      compareValue = $(this).closest('.product-wrap').find('.prev-value:first').text();

      if($(this).is(':first-child') && $(this).text() != ""){
        $(this).addClass('force-display');
      }else if($(this).is(':first-child') && compareValue.trim() != '$0.00'){
        $(this).text(compareValue);
        $(this).addClass('force-display');
      }else{
        $(this).hide();
      }

      if($(this).is(':first-child') && compareValue.trim() != '$0.00'){
        $(this).text(compareValue);
        $(this).show();
      }
      
      if ($(this).parents('.js-recently-viewed-product').length) {
        $(this).parent().css("justify-content");
        $(this).css("padding-left", "0");
        $(this).next().css("padding-left", "0");
      }
      $(this).parent().addClass('custom-flex-price');
      $(this).addClass('custom-money-details');

    })
  },5000)
}

const HELP_SCOUT_IFRAME_STYLES = `
button span {
  font-size: 28px !important;
  line-height: 2em !important;
}
`

function addStylesToHelpScoutIframe(iframeElement) {
  const newStyles = document.createElement("style");
  newStyles.textContent = HELP_SCOUT_IFRAME_STYLES;
  iframeElement.contentDocument.head.appendChild(newStyles);
  const observer = new MutationObserver(function (e) {
    if (e[0].removedNodes){
      searchHelpScoutIframe();
      observer.disconnect();
    }
  });
  observer.observe(iframeElement.parentElement, { childList: true });
}

function searchHelpScoutIframe() {
  const isMobile = window.innerWidth <= 1025;
  if(!isMobile) return;
  const checkInterval = setInterval(() => {
    const helpScoutIframes = document.querySelectorAll("iframe[data-cy='FrameComponent']");
    const hasHelpScoutIframe = helpScoutIframes && helpScoutIframes.length > 0;
    if(hasHelpScoutIframe) {
      clearInterval(checkInterval);
      addStylesToHelpScoutIframe(helpScoutIframes[helpScoutIframes.length - 1]);
    }
  }, 300);
}


// Document Ready
$(function () {

  var pathArray = window.location.pathname.split('/');

  if(pathArray[1] == 'collections'){
    styleCompareAtPrice();
  }else if(pathArray[1] == 'products' && pathArray[2]){
    comparValue = $('.prev-value').text();

      if($('.money-details').text() == "" && !comparValue.includes('$0.00')){
        //$('.current_price').append('<span class="money-details bold-compare-at-money">' + comparValue + '</span>');
      }
  }

  /**** VARIABLES INITIALIZATION *****/
  var sizesEu = new Array();
  var sizesUs = new Array();
  var sizesEl = "div.custom-swatch-size";
  var borderRedClass = "border-red";

  $(sizesEl).each(function (index, el) {
    var size = $(el).data("value");
    var id = $(el).data("id");
    if (size && size.indexOf("|") > -1) {
      sizesEu[id] = size.split("|")[0].trim();
      sizesUs[id] = size.split("|")[1].trim();
    }
  });
  /**** END VARIABLES INITIALIZATION *****/

  /**** SETUP *****/
  initSizes(sizesUs);
  /**** END SETUP *****/

  /**** MODIFY HELP SCOUT IFRAME STYLES ****/
  if(window.location.pathname.includes('/pages/customize'))
    searchHelpScoutIframe();

  /**** EVENT HANDLERS *****/
  // Handle US size click
  $("a.prod-size-us").on("click", function (e) {
    e.preventDefault();
    initSizes(sizesUs);
    $(".custom-product-sizes-actions a").toggleClass(
      "custom-link custom-no-link"
    );
  });

  // Handle EU size click
  $("a.prod-size-eu").on("click", function (e) {
    e.preventDefault();
    initSizes(sizesEu);
    $(".custom-product-sizes-actions a").toggleClass(
      "custom-link custom-no-link"
    );
  });

  // Handle radio button checked
  $(".swatch_options input:radio").on("click", function (e) {
    $(sizesEl).removeClass(borderRedClass);
  });

  $("button.add_to_cart").on("click", function (e) {
    if (!$(".swatch_options input:radio").is(":checked")) {
      $(sizesEl).addClass(borderRedClass);
    }
  });

  $("input[type=radio][name=option-0]").change(function () {
    $(".money_custom").text(this.value);
  });


  /**** END EVENT HANDLERS *****/

  //Hide Sale Div

  $(".sale_banner_product").hide();

  /**** FUNCTIONS *****/
  function initSizes(sizesArr) {
    for (var key in sizesArr) {
      $("div.custom-swatch-size[data-id=" + key + "] label").text(
        sizesArr[key].split(" ")[1]
      );
    }
  }
  /**** END FUNCTIONS *****/
});
